import React from "react"

import AuthenticatedApp from "@/components/ui/AuthenticatedApp"
import ChatPage from "@/components/ui/ChatPage"

const authentication = process.env.REACT_APP_AUTHENTICATION ?? "off"

const App: React.FC = () => {
    if (authentication === "on") {
        return <AuthenticatedApp />
    }

    return <ChatPage />
}

export default App
